if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.querySelector('.product-media-modal__dialog')?.addEventListener('pointerup', (event) => event.stopPropagation());
        this.querySelector('[data-product-media-prev]')?.addEventListener('click', this.showPreviousMedia.bind(this));
        this.querySelector('[data-product-media-next]')?.addEventListener('click', this.showNextMedia.bind(this));
        this.querySelectorAll('[data-product-media-thumb]').forEach((thumbnail) => {
          thumbnail.addEventListener('click', this.onThumbnailClick.bind(this));
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        const activeMedia = this.getMediaById(mediaId) || this.getMediaItems()[0];
        if (!activeMedia) return;

        this.setActiveMedia(activeMedia);
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('[role="document"] > [data-media-id]'));
      }

      getMediaById(mediaId) {
        if (!mediaId) return null;
        return this.getMediaItems().find((media) => media.getAttribute('data-media-id') === mediaId);
      }

      getThumbnails() {
        return Array.from(this.querySelectorAll('[data-product-media-thumb]'));
      }

      setActiveMedia(activeMedia) {
        this.getMediaItems().forEach((element) => {
          element.classList.toggle('active', element === activeMedia);
        });
        this.setActiveThumbnail(activeMedia.getAttribute('data-media-id'));

        const deferredMedia = activeMedia.matches('deferred-media, product-model')
          ? activeMedia
          : activeMedia.querySelector('deferred-media, product-model');

        this.loadDeferredMedia(activeMedia, deferredMedia);
      }

      loadDeferredMedia(activeMedia, deferredMedia) {
        if (!deferredMedia) return;

        const loadMedia = () => {
          if (!this.hasAttribute('open') || !activeMedia.classList.contains('active')) return;
          if (typeof deferredMedia.loadContent === 'function') deferredMedia.loadContent(false);
        };

        if (typeof deferredMedia.loadContent === 'function') {
          loadMedia();
          return;
        }

        const tagName = deferredMedia.tagName.toLowerCase();
        if (window.customElements && customElements.get(tagName)) {
          loadMedia();
          return;
        }

        if (window.customElements) customElements.whenDefined(tagName).then(loadMedia);
      }

      setActiveThumbnail(mediaId) {
        this.getThumbnails().forEach((thumbnail) => {
          const isActive = thumbnail.getAttribute('data-media-id') === mediaId;
          thumbnail.classList.toggle('is-active', isActive);
          if (isActive) {
            thumbnail.setAttribute('aria-current', 'true');
          } else {
            thumbnail.removeAttribute('aria-current');
          }
        });
      }

      onThumbnailClick(event) {
        event.preventDefault();
        const media = this.getMediaById(event.currentTarget.getAttribute('data-media-id'));
        if (!media) return;

        window.pauseAllMedia();
        this.setActiveMedia(media);
      }

      showPreviousMedia() {
        this.showAdjacentMedia(-1);
      }

      showNextMedia() {
        this.showAdjacentMedia(1);
      }

      showAdjacentMedia(direction) {
        const mediaItems = this.getMediaItems();
        if (mediaItems.length < 2) return;

        const activeIndex = mediaItems.findIndex((media) => media.classList.contains('active'));
        const currentIndex = activeIndex === -1 ? 0 : activeIndex;
        const nextIndex = (currentIndex + direction + mediaItems.length) % mediaItems.length;

        window.pauseAllMedia();
        this.setActiveMedia(mediaItems[nextIndex]);
      }
    }
  );
}
